import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiRoutes from "../../../api/apiRoutes";
// import { authorizedFetch } from '../../../utils/auth';
import { apiFetchJson } from "../../../utils/http";
// import { shouldRunOnce } from '../../../utils/devOnce'; // ← ya no lo usamos aquí

// usa SIEMPRE el id real
const CLIENTES_BASE = (apiRoutes?.clientes?.list || "").replace(/\/list$/, "");
const DETALLE_URL = (id) => `${CLIENTES_BASE}/${encodeURIComponent(id)}`;

export default function VerClientes({
  idCliente: idFromProp = null,
  onClose = null,
}) {
  // si viene por ruta directa, seguimos soportando /clientes/:idCliente
  const params = useParams();
  const navigate = useNavigate();

  const idCliente = idFromProp ?? params.idCliente;

  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  // ✅ Evitar el patrón “fetch abortado” de StrictMode:
  // en DEV saltamos la PRIMERA ejecución del efecto y dejamos correr la segunda.
  const devRunRef = useRef(false);

  useEffect(() => {
    if (!idCliente) return;

    if (process.env.NODE_ENV !== "production") {
      if (!devRunRef.current) {
        devRunRef.current = true; // marcamos y NO ejecutamos todavía
        return;
      }
    }

    const ac = new AbortController();
    setCargando(true);
    setError("");

    (async () => {
      try {
        // Wrapper maneja 401/403 y parsea JSON
        const json = await apiFetchJson(DETALLE_URL(idCliente), {
          signal: ac.signal,
        });
        setData(json);
      } catch (e) {
        if (ac.signal.aborted) return;
        setError(e?.message || "Error");
      } finally {
        if (!ac.signal.aborted) setCargando(false);
      }
    })();

    return () => ac.abort();
  }, [idCliente]);

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* Encabezado */}
        <div className="modal-header">
          <h2 className="section-title">Datos de Cliente</h2>
        </div>

        {/* Contenido */}
        <div className="modal-body">
          {cargando ? (
            <div className="text-center py-12">Cargando...</div>
          ) : error ? (
            <div className="text-red-600 text-center py-12">Error: {error}</div>
          ) : (
            <div className="form-grid">
              {[
                ["Código", data.codigo],
                ["Nombre", data.nombre],
                ["Tipo de Documento", data.codigoTipodocumento],
                ["Documento", data.documento],
                ["Estado", data.estadoNombre ?? data.estado],
                ["Ciudad", data.ciudadNombre],
                ["Teléfono1", data.dataTelefono1],
                ["Teléfono2", data.dataTelefono2],
                //['Fax', data.dataFax],
                ["Crédito Máximo", data.valorCreditomaximo],
                ["Email", data.dataEmail],
                ["Dirección", data.dataDireccion],
                ["Observaciones", data.textoObservaciones],
                ["Cuenta Padre", data.codigoCuentaPadre],
                ["Moneda", data.monedaNombre],
                ["Alerta Correo", data.clieCdAlertaE],
              ].map(([label, val]) => (
                <Fila key={label} label={label} value={val} />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button onClick={onClose} className="btn-fil">
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value}</div>
    </div>
  );
}
